import {
  Datagrid,
  DeleteButton,
  EditButton,
  List,
  TextField,
  TextInput,
  useLocale,
} from 'react-admin';

const companyFilter = [
  <TextInput
    sx={{ marginBottom: 1 }}
    source="name"
    defaultValue=""
    key="name_q"
    alwaysOn
  />,
  <TextInput
    sx={{ marginBottom: 1 }}
    source="cnpj"
    defaultValue=""
    key="cnpj_q"
  />,
];

export const CompanyList = () => {
  const locale = useLocale();
  return (
    <List filters={companyFilter}>
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        sort={{ field: 'id', order: 'DESC' }}
      >
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="cnpj" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
